<ngb-toast
	*ngIf="messageToast && isVisible"
	[autohide]="false"
	[animation]="false"
	[class]="'ui-v2-toast ' + messageToastType.className"
	[class.has-toast-time]="remainingTime || timeAgo"
	[@fadeInRightOnEnter]
	[@fadeOutRightOnLeave]
	(@fadeOutRightOnLeave.done)="onCloseAnimationDone($event)"
>
	<!-- close toast -->
	<button
		type="button"
		class="close-toast"
		aria-label="Close notification"
		(click)="close()"
	>
		<ng-fa-icon
			class="d-inline-flex"
			icon="xmark"
		></ng-fa-icon>
	</button>

	<!-- show timing info -->
	<div
		class="toast-top-info-container"
		*ngIf="remainingTime || timeAgo"
	>
		<small
			class="toast-right-top-info"
			*ngIf="remainingTime"
		>
			<ng-message-time
				[option]="EnumTimeOptions.remainingTime"
				[time]="remainingTime"
				(exactTimeOver)="exactTimeOver($event)"
			></ng-message-time>
		</small>
		<small
			class="toast-right-top-info"
			*ngIf="timeAgo"
		>
			<ng-message-time
				[option]="EnumTimeOptions.pastTime"
				[time]="timeAgo"
			></ng-message-time>
		</small>
	</div>

	<!-- show toast info -->
	<div class="toast-info-container">
		<!-- toast icon -->
		<div class="icon-container">
			<ng-fa-icon
				class="d-inline-flex toast-icon"
				[icon]="messageToast.icon.name"
				[iconStyle]="messageToast.icon!.style"
			></ng-fa-icon>
		</div>

		<!-- toast message -->
		<div class="message-container">
			<div class="d-flex">
				<strong
					class="message-toast-title text-truncate"
					[ngTooltip]="messageToast.title"
					container="body"
					tooltipClass="app-tooltip message-toast-tooltip"
					triggers="manual"
					#titleTooltip="ngTooltip"
					(mouseenter)="openMessageTooltip(titleTooltip, $event)"
					(mouseleave)="scheduleMessageTooltipClose()"
					onlyTruncate
				>
					{{ messageToast.title }}
				</strong>
			</div>
			<div
				class="message-toast-desc text-truncate"
				[ngTooltip]="messageToast.message"
				container="body"
				tooltipClass="app-tooltip message-toast-tooltip"
				triggers="manual"
				#messageTooltip="ngTooltip"
				(mouseenter)="openMessageTooltip(messageTooltip, $event)"
				(mouseleave)="scheduleMessageTooltipClose()"
				onlyTruncate
			>
				{{ messageToast.message }}
			</div>
		</div>

		<!-- toast action -->
		<div
			class="action-container"
			*ngIf="messageToast.actions.length"
		>
			<!-- in case of only one button -->
			<button
				*ngIf="
					messageToast.actions &&
						messageToast.actions.length === 1 &&
						messageToast.actions[0].label.length < MAX_BUTTON_LABEL_LENGTH;
					else messageToastOptions
				"
				class="btn toast-action-button"
				(click)="messageToast.actions[0].execute(); onAction$.next(messageToast.actions[0].label)"
			>
				{{ messageToast.actions[0].label }}
			</button>

			<!-- in case of more than one button -->
			<ng-template #messageToastOptions>
				<div
					class="d-inline-block"
					ngbDropdown
					container="body"
					placement="bottom-right"
					dropdownClass="message-toast-action"
				>
					<a
						class="btn toast-action-button"
						id="dropdownOptions"
						ngbDropdownToggle
					>
						Option
						<span
							class="ms-2"
							aria-hidden="true"
						>
							<ng-fa-icon
								class="d-inline-flex"
								icon="chevron-down"
							></ng-fa-icon>
						</span>
					</a>
					<div
						ngbDropdownMenu
						aria-labelledby="dropdownOptions"
					>
						<button
							ngbDropdownItem
							(click)="action.execute(); onAction$.next(action.label)"
							class="btn btn-default"
							*ngFor="let action of messageToast.actions"
						>
							{{ action.label }}
						</button>
					</div>
				</div>
			</ng-template>
		</div>
	</div>

	<!-- Progress Bar -->
	<div
		class="toast-progress-track"
		*ngIf="messageToast.progress > 0"
	>
		<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
		<div
			class="toast-progress"
			[style.width]="(messageToast.progress > 100 ? 100 : messageToast.progress) + '%'"
		></div>
	</div>
</ngb-toast>
